import { render, staticRenderFns } from "./InsFeature.vue?vue&type=template&id=3b952718&scoped=true"
import script from "./InsFeature.vue?vue&type=script&lang=ts"
export * from "./InsFeature.vue?vue&type=script&lang=ts"
import style0 from "./InsFeature.vue?vue&type=style&index=0&id=3b952718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b952718",
  null
  
)

export default component.exports